module.exports = __webpack_public_path__ + "static/media/3.44325f89.JPG";